import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  userId: number | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  userId: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (
      state,
      action: PayloadAction<{
        token: string;
        refreshToken: string;
        userId: number;
      }>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.userId = action.payload.userId;
      state.isAuthenticated = true;
      localStorage.setItem("access_token", action.payload.token);
      localStorage.setItem("refresh_token", action.payload.refreshToken);
      localStorage.setItem("user_id", action.payload.userId.toString());
    },
    updateToken: (state, action: PayloadAction<{ token: string }>) => {
      state.token = action.payload.token;
      localStorage.setItem("access_token", action.payload.token);
    },
    clearAuth: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.userId = null;
      state.isAuthenticated = false;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_id");
    },
    loadAuthFromStorage: (state) => {
      const token = localStorage.getItem("access_token");
      const refreshToken = localStorage.getItem("refresh_token");
      const userId = localStorage.getItem("user_id");

      if (token && refreshToken && userId) {
        state.token = token;
        state.refreshToken = refreshToken;
        state.userId = parseInt(userId, 10);
        state.isAuthenticated = true;
      } else {
        // Если токенов нет, очищаем состояние
        state.token = null;
        state.refreshToken = null;
        state.userId = null;
        state.isAuthenticated = false;
      }
    },
  },
});

export const { setAuth, updateToken, clearAuth, loadAuthFromStorage } =
  authSlice.actions;
export default authSlice.reducer;
